import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';
import {
  BuildingStorefrontIcon,
  ArrowRightIcon,
} from '@heroicons/react/24/solid';
import { useAuth } from '../../contexts/AuthContext';

const PublicNavbar: React.FC<{ solid?: boolean }> = ({ solid = false }) => {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();
  const [scrolled, setScrolled] = useState(solid);

  useEffect(() => {
    if (solid) { setScrolled(true); return; }
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [solid]);

  return (
    <nav
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        padding: scrolled ? '12px 0' : '18px 0',
        background: scrolled ? 'rgba(255,255,255,0.95)' : 'transparent',
        backdropFilter: scrolled ? 'blur(12px)' : 'none',
        boxShadow: scrolled ? '0 2px 20px rgba(0,0,0,0.08)' : 'none',
        transition: 'all 0.3s ease',
      }}
    >
      <Container className="d-flex align-items-center justify-content-between">
        <div
          className="d-flex align-items-center gap-2"
          role="link"
          tabIndex={0}
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/')}
          onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && navigate('/')}
        >
          <BuildingStorefrontIcon style={{ width: '28px', height: '28px', color: scrolled ? '#1e3a8a' : 'white' }} />
          <span style={{ fontSize: '1.3rem', fontWeight: 700, color: scrolled ? '#1e3a8a' : 'white', letterSpacing: '-0.5px' }}>
            Sourdoughsy
          </span>
        </div>
        <div className="d-flex align-items-center gap-2">
          {isAuthenticated ? (
            <Button
              variant="link"
              onClick={() => navigate(user?.role === 'company' ? '/company/dashboard' : '/customer-dashboard')}
              className="d-inline-flex align-items-center gap-1"
              style={{
                borderRadius: '999px',
                padding: '8px 24px',
                fontWeight: 600,
                fontSize: '0.9rem',
                background: scrolled ? 'linear-gradient(135deg, #1e3a8a, #3b82f6)' : 'white',
                color: scrolled ? 'white' : '#1e3a8a',
                border: 'none',
                transition: 'all 0.3s ease',
                textDecoration: 'none',
                boxShadow: '0 2px 10px rgba(0,0,0,0.15)',
              }}
            >
              Dashboard
              <ArrowRightIcon style={{ width: '14px', height: '14px' }} />
            </Button>
          ) : (
          <>
          <Button
            variant="link"
            onClick={() => navigate('/customer-login')}
            style={{
              borderRadius: '999px',
              padding: '8px 24px',
              fontWeight: 600,
              fontSize: '0.9rem',
              borderColor: scrolled ? '#1e3a8a' : 'rgba(255,255,255,0.6)',
              color: scrolled ? '#1e3a8a' : 'white',
              background: 'transparent',
              border: scrolled ? '2px solid #1e3a8a' : '2px solid rgba(255,255,255,0.6)',
              transition: 'all 0.3s ease',
              textDecoration: 'none',
            }}
          >
            Log In
          </Button>
          <Button
            variant="link"
            onClick={() => navigate('/register')}
            className="d-none d-sm-inline-flex align-items-center gap-1"
            style={{
              borderRadius: '999px',
              padding: '8px 24px',
              fontWeight: 600,
              fontSize: '0.9rem',
              background: scrolled ? 'linear-gradient(135deg, #1e3a8a, #3b82f6)' : 'white',
              color: scrolled ? 'white' : '#1e3a8a',
              border: 'none',
              transition: 'all 0.3s ease',
              textDecoration: 'none',
              boxShadow: '0 2px 10px rgba(0,0,0,0.15)',
            }}
          >
            Get Started
            <ArrowRightIcon style={{ width: '14px', height: '14px' }} />
          </Button>
          </>
          )}
        </div>
      </Container>
    </nav>
  );
};

export default PublicNavbar;
